import { render } from "./nodoctor.vue?vue&type=template&id=736b23f8&scoped=true"
import script from "./nodoctor.vue?vue&type=script&lang=js"
export * from "./nodoctor.vue?vue&type=script&lang=js"

import "./nodoctor.vue?vue&type=style&index=0&id=736b23f8&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736b23f8"]])

export default __exports__